import { useCallback, useMemo } from "react";
import QueueAttendanceItem from "./components/QueueAttendance/subcomponents/SingleItem";
import { handleException, handleStatusIcon, handleTime } from "./functions/chat";
import mobile from "../../assets/images/from/phone.png";
import web from "../../assets/images/from/web.png";
import { useConversationDescription } from "./hooks/useConversationDescription";

export function ConversationItem({ conversation, onClick, activeChat, getChat, extraClickArgs }) {
  const handleClick = useCallback(
    (event) => onClick?.(conversation, event, extraClickArgs),
    [conversation, onClick, extraClickArgs]
  )

  const name = useMemo(() => {
    return conversation?.consumer?.displayName ?? conversation?.consumer?.name
  }, [conversation?.consumer?.displayName, conversation?.consumer?.name])

  const description = useConversationDescription(conversation)

  const isActive = useMemo(() => {
    if (activeChat?.conversation?.conversationId === conversation.conversationId)
      return "conversation-active"

    return ''
  }, [activeChat?.conversation?.conversationId, conversation.conversationId])

  const isClosed = useMemo(() => conversation.status === 'closed', [conversation.status])

  const from = useMemo(() => {
    if (conversation.channel === 'telegram' || conversation.channel === 'whatsapp') return mobile

    return web
  }, [conversation.channel])

  const time = useMemo(() => handleTime(conversation, getChat), [conversation, getChat])

  const status = useMemo(
    () => handleStatusIcon(conversation, getChat),
    [conversation, getChat]
  )

  const statusTooltip = useMemo(
    () => handleException(conversation, getChat),
    [conversation, getChat]
  )

  return (
    <div>
      <QueueAttendanceItem
        id={`chat-${conversation?.conversationId}`}
        conversation={conversation}
        onClick={handleClick}
        name={name}
        description={description}
        isActive={isActive}
        isClosed={isClosed}
        time={time}
        from={from}
        image={null}
        status={status}
        statusTooltip={statusTooltip}
      />
    </div>
  )
}
